import {
  apiDelete, apiGet, apiPost, apiPut,
} from './_common';

export default {
  getById(id) {
    return apiGet(`/magenta/admin/${id}`)
      .then(result => result.response);
  },
  // SnowflakeSearchList passes { query, orderBy, sortDirection, page, pageSize }; the server does the
  // filtering, sorting and paging and returns a { results, totalCount } page.
  search(options) {
    return apiGet('/magenta/admin', options)
      .then(result => result.response);
  },
  roles() {
    return apiGet('/magenta/admin/roles')
      .then(result => result.response);
  },
  create(request) {
    return apiPost('/magenta/admin', request)
      .then(result => result.response);
  },
  update(id, request) {
    return apiPut(`/magenta/admin/${id}`, request)
      .then(result => result.response);
  },
  delete(id) {
    return apiDelete(`/magenta/admin/${id}`)
      .then(result => result.response);
  },
};
